import React from 'react';
import styled from 'styled-components';
import {useRouter} from 'next/router';
import {useTranslations} from "use-intl";

import {getAliasString, getCurrentProject} from '@/utils/common';
import {useTypedSelector} from '@/store/store';
import {selectProductResource} from '@/store/reducers/pages/product/product';
import {colors} from '@/constants/theme';
import MultiPrice from '@/modules/Product/components/Main/components/MultiPrice';
import ContentContainer from '@/components/ContentContainer';
import TextWithIcon from '@/components/TextWithIcon';
import Link from '@/components/Link';
import {BLOG_TISSUE_URL} from '@/product';
import {getOrderType} from '@/modules/Product/components/Main/helpres';

import Price from './components/Price';
import Related from './components/Related';
import Brand from './components/Brand';
import Tabs from './components/Tabs';
import Order from './components/Order';
import Cheaper from './components/Cheaper';

function Main() {
  const router = useRouter();
  const alias = getAliasString(router.query.alias);
  const product = useTypedSelector((state) => {
    return selectProductResource(state, alias);
  });

  const t = useTranslations();

  const availability = getOrderType(product.data?.availability, t);
  const waitingDays = product.data?.waitingDays ?? 0;


  return (
    <Component>
      <OrderType>
        {availability} {waitingDays > 0 ? waitingDays + ' ' + t('dimensions.days') : null}
      </OrderType>
      <Price/>
      <MultiPrice product={product.data}/>
      {getCurrentProject() !== 'dveri' &&
        <ContentContainer>
          <Link to={BLOG_TISSUE_URL}>
            <TissueBotton>{t('product.tissue_more')}</TissueBotton>
          </Link>
          <Related product={product.data}/>
        </ContentContainer>
      }
      <Order product={product.data}/>
      <TextWithIconWrapper>
        <TextWithIcon
          icon="delivery"
          note={ getCurrentProject() === 'dveri'
            ? t('product.delivery_kiev')
            : t('product.delivery_minsk')}
          text={t('product.free')}
          hasColor
          fontWeight={600}
        />
        <Cheaper product={product.data}/>
      </TextWithIconWrapper>
      {getCurrentProject() !== 'dveri' &&
        <ContentContainer>
          <Brand product={product.data}/>
        </ContentContainer>
      }
      <Tabs product={product.data}/>
    </Component>
  );
}

export default Main;

const Component = styled.div``;
const OrderType = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  background: ${colors.grayBackground};
`;

const TissueBotton = styled.div`
  margin-top: 2px;
  cursor: pointer;
  display: inline-block;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;
  color: ${colors.primary};
`;

const TextWithIconWrapper = styled.div`
  padding: 11px 15px 13px;
  border-bottom: 1px solid ${colors.gray70};

  & > div:not(:first-child) {
    margin-top: 9px;
  }
`;
